import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getManagementCtContent = createAsyncThunk('/managementkontrak/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listContractFile/${userId}?page=${nopage}`, {})
    return response.data;
})

export const managementkontrakSlice = createSlice({
    name: 'managementkontrak',
    initialState: {
        isLoading: false,
        managementkontrak : []
    },
    reducers: {


        addNewManagementkontrak: (state, action) => {
            let {newMangementkontrakObj} = action.payload
            state.managementkontrak = [...state.managementkontrak, newMangementkontrakObj]
        },

        deleteMangementkontrak: (state, action) => {
            let {index} = action.payload
            state.managementkontrak.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getManagementCtContent.pending]: state => {
			state.isLoading = true
		},
        [getManagementCtContent.fulfilled]: (state, action) => {
            state.managementkontrak = action.payload.data
			state.isLoading = false
		},
        [getManagementCtContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
   
    extraReducers: (builder) => {       
        builder
        .addCase(getManagementCtContent.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getManagementCtContent.fulfilled, (state, action) => {
            state.managementkontrak = action.payload.data;
            state.isLoading = false;
        })
        .addCase(getManagementCtContent.rejected, (state) => {
            state.isLoading = false;
        });
    }
})

export const { addNewManagementkontrak, deleteMangementkontrak } = managementkontrakSlice.actions

export default managementkontrakSlice.reducer